import { fromJS } from 'immutable';
import { AvatarActionTypes } from '../actions/AvatarActions';
const defaultState = fromJS({
  updatedAt: null
});
export default function Avatar(state = defaultState, action) {
  switch (action.type) {
    case AvatarActionTypes.UPDATE_AVATAR:
      return state.set('updatedAt', action.payload.data.updatedAt);
    default:
      return state;
  }
}